<template>
  <div class="retract">
    <draggable :list="paragraphs">
      <el-menu-item
        class="sort-item"
        :index="item.title"
        v-for="item in paragraphs"
        :key="item.title"
        @click="handleScrollToParagraph(item.paragraphId)"
      >
        <i class="el-icon-sort"></i>
        {{ item.title }}
        <el-popconfirm
          title="确定删除吗？"
          class="hideen"
          @confirm="handleDelete(item)"
        >
          <i
            slot="reference"
            class="el-icon-delete delete-item"
            @click.stop="() => {}"
          ></i>
        </el-popconfirm>
      </el-menu-item>
    </draggable>
    <div class="add-paragraph" @click="handleShowAddDialog">
      <i class="el-icon-circle-plus-outline"></i>
      添加空间
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  inject: ["editControl"],
  props: {
    paragraphs: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({}),
  methods: {
    handleDelete(item) {
      const index = this.paragraphs.indexOf(item);
      this.paragraphs.splice(index, 1);
    },
    handleShowAddDialog() {
      this.editControl.handleShowAddDialog();
    },
    handleScrollToParagraph(id) {
      this.editControl.handleScrollToParagraph(id);
    },
  },
};
</script>

<style lang="scss" scoped>
.retract {
  margin-left: -20px;
  .el-menu-item,
  .el-submenu__title {
    height: 46px;
    line-height: 46px;
    cursor: move;
  }
  .sort-item {
    display: flex;
    align-items: center;
  }
  .hideen {
    display: none;
    cursor: pointer;
  }
  .sort-item:hover .hideen {
    display: inline-block;
  }
  .sort-item:hover .delete-item {
    margin-left: 30px;
    cursor: pointer;
  }
  .add-paragraph {
    font-size: 14px;
    height: 46px;
    line-height: 46px;
    padding: 0 45px;
    cursor: cell;
    padding-left: 40px;
    min-width: 200px;
    text-align: left;
    font-weight: bold;
  }
}
</style>